import { apiV2 } from "./apiV2"

const eventsApi = apiV2.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: () => "interfester/events/all",
      providesTags: ["Events"],
    }),
    createEvent: builder.mutation({
      query: (event) => ({
        url: "interfester/events/add",
        method: "POST",
        body: event,
      }),
      invalidatesTags: ["Events"],
    }),
    updateEvent: builder.mutation({
      query: (event) => ({
        url: `interfester/events/edit/${event.eventId}`,
        method: "POST",
        body: event,
      }),
      invalidatesTags: ["Events"],
    }),
    deleteEvent: builder.mutation({
      query: (id) => ({
        url: `interfester/events/delete/${id}`,
        method: "POST",
      }),
      invalidatesTags: ["Events"],
    }),
  }),
})

export const {
  useGetEventsQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
} = eventsApi
